var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPromaxPricing = function SvgIconPromaxPricing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_promax_pricing_svg__a)",
    d: "M15.105 10 12 22.5 8.895 10h6.21Zm-3.96-7.501L9.022 8.333h5.954l-2.121-5.834h-1.712Zm5.605 5.834h5.118a2.476 2.476 0 0 0-.333-.667l-2.943-4.12A2.5 2.5 0 0 0 16.558 2.5h-1.929l2.121 5.834Zm.071 1.666-2.304 9.417 6.95-8.75a2.47 2.47 0 0 0 .367-.667H16.82ZM7.18 10H2.166c.089.24.214.465.371.667l6.946 8.75L7.18 10Zm.07-1.666 2.122-5.834H7.442a2.5 2.5 0 0 0-2.034 1.048L2.465 7.666a2.455 2.455 0 0 0-.333.667H7.25Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_promax_pricing_svg__a",
    x1: 9.955,
    x2: 14.352,
    y1: 9.448,
    y2: 26.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B2"
  })))));
};
export default SvgIconPromaxPricing;